import { render, staticRenderFns } from "./UploadIcon.vue?vue&type=template&id=4ee8dc04&"
import script from "./UploadIcon.vue?vue&type=script&lang=js&"
export * from "./UploadIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports